export default __webpack_public_path__ + "static/media/4.d462e339.png";